export const formatPhoneNumber = (value) => {
    const phoneNumber = value.replace(/\D/g, '');
    if (phoneNumber.length === 0)
        return '';
    if (phoneNumber.length <= 3)
        return `(${phoneNumber}`;
    if (phoneNumber.length <= 6)
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
export const extractPhoneNumber = (phoneData) => {
    if (typeof phoneData === 'string')
        return phoneData;
    return phoneData?.number || '';
};
export const extractAddressData = (address) => {
    if (typeof address === 'string') {
        return { street_1: address, street_2: '', city: '', state: '', postal_code: '' };
    }
    return {
        street_1: address?.street_1 || '',
        street_2: address?.street_2 || '',
        city: address?.city || '',
        state: address?.state || '',
        postal_code: address?.postal_code || '',
    };
};
export const transformApiData = (formData, clinic) => {
    const apiData = {
        name: formData.name,
        email: formData.email,
        is_corporation_owned: formData.is_corporation_owned === 'yes',
        corporation_name: formData.corporation_name || null,
        custom_corporation_name: formData.custom_corporation_name || null,
        buying_group: formData.buying_group || null,
        other_buying_group: formData.other_buying_group || null,
    };
    const currentAddress = extractAddressData(clinic.address);
    const addressChanged = formData.street_1 !== currentAddress.street_1 ||
        formData.street_2 !== currentAddress.street_2 ||
        formData.city !== currentAddress.city ||
        formData.state !== currentAddress.state ||
        formData.postal_code !== currentAddress.postal_code;
    if (addressChanged) {
        apiData.address = {
            street1: formData.street_1,
            street2: formData.street_2,
            city: formData.city,
            state: formData.state,
            postalCode: formData.postal_code,
        };
    }
    const currentPhone = extractPhoneNumber(clinic.phone);
    if (formData.phone !== currentPhone) {
        if (formData.phone) {
            const cleanPhone = formData.phone.replace(/\D/g, '');
            apiData.phone = { number: cleanPhone };
        }
        else {
            apiData.phone = null;
        }
    }
    const currentFax = extractPhoneNumber(clinic.fax);
    if (formData.fax !== currentFax) {
        if (formData.fax) {
            const cleanFax = formData.fax.replace(/\D/g, '');
            apiData.fax = { number: cleanFax };
        }
        else {
            apiData.fax = null;
        }
    }
    const currentAlternatePhone = extractPhoneNumber(clinic.alternate_phone);
    if (formData.alternate_phone !== currentAlternatePhone) {
        if (formData.alternate_phone) {
            const cleanAlternatePhone = formData.alternate_phone.replace(/\D/g, '');
            apiData.alternate_phone = { number: cleanAlternatePhone };
        }
        else {
            apiData.alternate_phone = null;
        }
    }
    const currentBillingAddress = clinic.billing_address ? extractAddressData(clinic.billing_address) : null;
    const billingAddressProvided = formData.billing_street_1 || formData.billing_city ||
        formData.billing_state || formData.billing_postal_code;
    if (billingAddressProvided) {
        const billingAddressChanged = !currentBillingAddress ||
            formData.billing_street_1 !== currentBillingAddress.street_1 ||
            formData.billing_street_2 !== currentBillingAddress.street_2 ||
            formData.billing_city !== currentBillingAddress.city ||
            formData.billing_state !== currentBillingAddress.state ||
            formData.billing_postal_code !== currentBillingAddress.postal_code;
        if (billingAddressChanged) {
            apiData.billingAddress = {
                street1: formData.billing_street_1,
                street2: formData.billing_street_2,
                city: formData.billing_city,
                state: formData.billing_state,
                postalCode: formData.billing_postal_code,
            };
        }
    }
    else if (currentBillingAddress) {
        apiData.billingAddress = null;
    }
    return apiData;
};
